import { z } from 'zod'

export const updateKinds = ['Новое', 'Улучшение', 'Исправление'] as const
export const productAreas = ['Сайт', 'CRM', 'Приложение', 'Админка'] as const
export const upcomingStatuses = ['В разработке', 'На тестировании', 'В плане'] as const

export const updateKindSchema = z.enum(updateKinds)
export const productAreaSchema = z.enum(productAreas)
export const upcomingStatusSchema = z.enum(upcomingStatuses)

export const updateSourceSchema = z.object({
  repo: z.string(),
  number: z.number().int().positive(),
  url: z.url(),
  title: z.string(),
  authors: z.array(z.string()).default([]),
})

export const releaseItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  summary: z.string(),
  changes: z.array(z.string()).default([]),
  kind: updateKindSchema,
  areas: z.array(productAreaSchema).default([]),
  version: z.string().nullable().default(null),
  date: z.iso.datetime(),
  source: updateSourceSchema,
})

export const upcomingItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  summary: z.string(),
  scope: z.array(z.string()).default([]),
  status: upcomingStatusSchema,
  areas: z.array(productAreaSchema).default([]),
  progress: z.number().min(0).max(100).nullable().default(null),
  when: z.string().nullable().default(null),
  stage: z.string().nullable().default(null),
  team: z.string().nullable().default(null),
  affects: z.string().nullable().default(null),
  next: z.string().nullable().default(null),
  source: updateSourceSchema,
})

export const updatesMetaSchema = z.object({
  generatedAt: z.iso.datetime(),
  lastReleaseAt: z.iso.datetime().nullable(),
  releasesLast30Days: z.number().int().nonnegative(),
  aiEnabled: z.boolean(),
  degraded: z.string().nullable().default(null),
  repositories: z.array(z.object({ repo: z.string(), areas: z.array(productAreaSchema) })),
  cachedAt: z.iso.datetime().nullable().default(null),
})

export const updatesResponseSchema = z.object({
  releases: z.array(releaseItemSchema),
  upcoming: z.array(upcomingItemSchema),
  meta: updatesMetaSchema,
})

export type UpdateKind = z.infer<typeof updateKindSchema>
export type ProductArea = z.infer<typeof productAreaSchema>
export type UpcomingStatus = z.infer<typeof upcomingStatusSchema>
export type UpdateSource = z.infer<typeof updateSourceSchema>
export type ReleaseItem = z.infer<typeof releaseItemSchema>
export type UpcomingItem = z.infer<typeof upcomingItemSchema>
export type UpdatesResponse = z.infer<typeof updatesResponseSchema>
